import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiChipTone } from '../../types/ui-chip-tone.type';

@Component({
  selector: 'ui-chip',
  imports: [],
  templateUrl: './ui-chip.component.html',
  styleUrl: './ui-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiChipComponent {
  public readonly active: InputSignal<boolean> = input<boolean>(false);
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly selectable: InputSignal<boolean> = input<boolean>(true);
  public readonly tone: InputSignal<UiChipTone> = input<UiChipTone>('neutral');
  public readonly selected: OutputEmitterRef<void> = output<void>();

  protected readonly isPrimary: Signal<boolean> = computed((): boolean => this.tone() === 'primary');
  protected readonly isSuccess: Signal<boolean> = computed((): boolean => this.tone() === 'success');
  protected readonly isWarning: Signal<boolean> = computed((): boolean => this.tone() === 'warning');
  protected readonly isDanger: Signal<boolean> = computed((): boolean => this.tone() === 'danger');

  protected handleClick(event: MouseEvent): void {
    if (this.disabled() || !this.selectable()) {
      event.preventDefault();
      return;
    }

    this.selected.emit();
  }
}
